if (!customElements.get('oralie-cart-checkout')) {
  class OralieCartCheckout extends HTMLElement {
    connectedCallback() {
      this.index = 0;
      const input = this.querySelector('[name="discount"]');
      const apply = this.querySelector('.odrawer-coupon__apply');
      const updateApply = () => { if (apply) apply.hidden = !input?.value.trim(); };
      input?.addEventListener('input', updateApply);
      updateApply();
      this.querySelector('form[data-drawer-discount]')?.addEventListener('submit', (event) => {
        event.preventDefault();
        const code = this.querySelector('[name="discount"]').value.trim();
        if (code) this.updateDiscount(code, false);
      });
      this.addEventListener('click', (event) => {
        const remove = event.target.closest('[data-remove-discount]');
        if (remove) this.updateDiscount(remove.dataset.removeDiscount, true);
        if (event.target.closest('[data-trust-next]')) this.showSlide(this.index + 1);
      });
      this.showSlide(0);
      this.timer = setInterval(() => {
        if (!this.isConnected || document.hidden || !this.closest('cart-drawer')?.classList.contains('active')) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || this.matches(':hover') || this.contains(document.activeElement) || input?.value.trim()) return;
        this.showSlide(this.index + 1);
      }, 4500);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    config() {
      try { return JSON.parse(this.querySelector('[data-checkout-config]').textContent); }
      catch (_) { return {}; }
    }
    showSlide(index) {
      const rows = [...this.querySelectorAll('[data-trust-slide]')];
      if (!rows.length) return;
      this.index = index % rows.length;
      rows.forEach((row, i) => { row.hidden = i !== this.index; });
    }
    cartCodes(cart) {
      const codes = Array.isArray(cart.discount_codes) ? cart.discount_codes.map((item) => item.code) : this.config().codes || [];
      return [...new Set(codes.filter((code) => typeof code === 'string' && code.trim()).map((code) => code.trim()))];
    }
    applied(cart, code) {
      if (Array.isArray(cart.discount_codes)) {
        return cart.discount_codes.some((item) => item.code?.toLowerCase() === code.toLowerCase() && item.applicable);
      }
      const applications = [...(cart.cart_level_discount_applications || [])];
      (cart.items || []).forEach((item) => (item.line_level_discount_allocations || []).forEach((allocation) => applications.push(allocation.discount_application)));
      if (applications.some((item) => item?.type === 'discount_code' && item.title?.toLowerCase() === code.toLowerCase())) return true;
      return null;
    }
    async updateDiscount(code, remove) {
      const drawer = this.closest('cart-drawer');
      const lock = window.OralieDrawerActions;
      if (!drawer || !lock?.beginMutation()) return;
      const config = this.config();
      let cart;
      let message = config.error;
      let failed = false;
      this.querySelectorAll('input, button').forEach((element) => { element.disabled = true; });
      this.setAttribute('aria-busy', 'true');
      try {
        const before = await drawer.readCart();
        let codes = this.cartCodes(before).filter((entry) => entry.toLowerCase() !== code.toLowerCase());
        if (!remove) codes.push(code);
        const result = await drawer.mutate(routes.cart_update_url, { discount: codes.join(',') });
        cart = Array.isArray(result.items) ? result : await drawer.readCart();
        const accepted = remove || this.applied(cart, code);
        message = remove ? config.removed : accepted === true ? config.applied : accepted === false ? config.invalid : config.pending;
        failed = accepted === false;
        await drawer.renderContents({ ...cart, sections: result.sections }, { mutation: true, open: false, focus: { id: 'CartDrawer-Discount' } });
      } catch (_) {
        failed = true;
        message = config.error;
        try { cart = await drawer.readCart(); await drawer.renderContents(cart, { mutation: true, open: false }); }
        catch (_) {}
      } finally {
        lock.endMutation();
        const current = drawer.querySelector('oralie-cart-checkout');
        if (current) {
          current.removeAttribute('aria-busy');
          current.querySelectorAll('[data-drawer-discount] input, [data-drawer-discount] button, [data-remove-discount], [data-trust-next]').forEach((element) => { element.disabled = false; });
          const status = current.querySelector('[data-discount-status]');
          status.textContent = message || config.error;
          status.classList.toggle('is-error', failed);
          status.classList.toggle('visually-hidden', !failed && message !== config.pending);
          const input = current.querySelector('[name="discount"]');
          if (input) input.value = '';
          const apply = current.querySelector('.odrawer-coupon__apply');
          if (apply) apply.hidden = true;
          if (failed) {
            if (config.clear) {
              const clear = document.createElement('button');
              clear.type = 'button';
              clear.dataset.removeDiscount = code;
              clear.textContent = config.clear;
              status.append(' ', clear);
            }
          }
          (input || current.querySelector('[data-remove-discount]'))?.focus({ preventScroll: true });
        }
      }
      if (cart && typeof publish === 'function') await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'oralie-cart-drawer', cartData: cart });
    }
  }
  customElements.define('oralie-cart-checkout', OralieCartCheckout);
}
